import SwiperCarousel from '../utils/swiper-carousel';

export default (element) => {
  const el = element.querySelector('[data-campaign-carousel]');

  if (!el) return;

  const init = () => {
    // eslint-disable-next-line no-new
    new SwiperCarousel(el, {
      slidesPerView: 1.2,
      spaceBetween: 15,
      allowTouchMove: true,
      centeredSlides: true,
      navigation: {
        nextEl: element.querySelector('.next'),
        prevEl: element.querySelector('.prev'),
      },
      breakpoints: {
        768: {
          spaceBetween: 22,
          slidesPerView: 3,
          centeredSlides: false,
          centerInsufficientSlides: true,
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  };

  init();
};
